package de.ohhhmhhh.backend.models.model.asset

import kotlinx.serialization.Serializable

@Serializable
data class UploadLinkResponse(
    val uploadUrl: String,
    val publicUrl: String
)
